import Swiper from 'swiper';
import { EffectFade, Pagination } from 'swiper/modules';

export class FloorPlanCarousel {
  
	el: HTMLElement
	swiper: Swiper
  slideEls: HTMLElement[]
  slideCount: number
	paginationEl: HTMLElement
    
	constructor(el) {
		this.el = el.querySelector('.swiper')
    this.paginationEl = el.querySelector('.swiper-pagination')
    this.slideEls = el.querySelectorAll('.swiper-slide')
    this.slideCount = this.slideEls.length

    if (this.slideEls.length > 1) {
		  this.init()
    }
	}

	init() {
		this.swiper = new Swiper(this.el, {
			modules: [EffectFade, Pagination],
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 500,
			slidesPerView: 1,
			allowTouchMove: true,
			pagination: {
        el: this.paginationEl,
        type: 'bullets',
        clickable: true,
        renderBullet: (index, className) => this.makeCustomBullet(index, className)
			},
      on: {
        'init': () => this.onSlideChange(),
        'slideChange': () => this.onSlideChange(),
      }
		})
	}

  makeCustomBullet(index, className) {
    return '<span class="' + className + '">' + this.getSlideTitle(index) + '</span>';
  }

  getSlideTitle(index) {
    return this.slideEls[index].getAttribute('data-tab-label') ?? 'Unknown'
  }

  onSlideChange() {
    const containerWidth = this.paginationEl.clientWidth
    const containerScrollWidth = this.paginationEl.scrollWidth
    if (!this.swiper || containerScrollWidth <= containerWidth) return
    const activeTab = this.paginationEl.children[this.swiper.activeIndex] as HTMLElement
    const lastElementCenter = activeTab.offsetLeft + (activeTab.offsetWidth * 0.5)
    const scrollToCenter = lastElementCenter - (containerWidth * 0.5)
    this.paginationEl.scrollLeft = Math.max(0, Math.min(containerScrollWidth - containerWidth, scrollToCenter))
  }
}